import { Controller } from '@hotwired/stimulus';
import Quill from 'quill';
import 'quill-mention';

export default class extends Controller {

    connect() {
        this.editor = this.element.querySelector('.dashboard-ql-editor');
        this.input = this.element.querySelector('.dashboard-ql-input');
        this.mentionable = [];

        this.quillConfig = {
            theme: 'snow',
            modules: {
                toolbar: false,
            },
        };

        if (this.element.dataset.mentionsUrl) {
            fetch(this.element.dataset.mentionsUrl)
                .then(response => response.json())
                .then(json => {
                    this.mentionable = json;
                })
                .catch((e) => {
                    console.error(e);
                });

            this.quillConfig.modules['mention'] = {
                mentionDenotationChars: ["@"],
                source: (searchTerm, renderList) => {
                    if (searchTerm.length === 0) {
                        renderList(this.mentionable, searchTerm);
                    } else {
                        const matches = [];
                        for (let i = 0; i < this.mentionable.length; i++) {
                            if (this.mentionable[i].value.toLowerCase().indexOf(searchTerm.toLowerCase()) >= 0) {
                                matches.push(this.mentionable[i]);
                            }
                        }

                        renderList(matches, searchTerm);
                    }
                },
            };
        }

        if (this.editor && this.input) {
            this.quill = new Quill(this.editor, this.quillConfig);

            this.quill.on('text-change', () => {
                this.input.value = JSON.stringify(this.quill.getContents());
            });

            if (this.input.value !== '' && this.quill) {
                this.quill.setContents(JSON.parse(this.input.value)['ops']);
            }
        }
    }
}
